export default __webpack_public_path__ + "static/media/MICE-events-dt@2x.0fa7ed14.jpg";